<template>
  <div id="home" class="outer">
    <div
      class="main"
      ref="main"
      :style="{ transform: 'scale(' + scaleX + ')' }"
    >
      <section class="left" ref="left">
        <left1></left1>
        <left2></left2>
        <left3></left3>
      </section>
      <section class="middle" ref="middle">
        <section class="map" ref="map">
          <div class="mapBox">
            <!-- <span class="deviceCount">
            <em class="title">设备总数</em>
            <strong>451</strong>
            <em class="unit">个</em>
          </span> -->
            <mp
              v-if="rootData && rootData.model == 0"
              :data="rootData"
              @changeArea="markerClick"
            ></mp>
            <visual
              class="map"
              :data="rootData"
              v-if="rootData && rootData.model == 1"
            ></visual>
          </div>
        </section>
        <middle></middle>
      </section>
      <section class="right" ref="right">
        <right1></right1>
        <right2></right2>
        <right3></right3>
      </section>
    </div>
    <!-- <webscoket ref="webscoket" :url='url'></webscoket> -->
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  data() {
    return {
      url: "",
      scaleX: 1,
      scaleY: 1,
      //地图
      deviceCount: 0,
      rootData: null
    };
  },
  components: {
    left1: () => import("./left1"),
    left2: () => import("./left2"),
    left3: () => import("./left3"),
    mp: () => import("./aMap"),
    visual: () => import("./visual"),
    middle: () => import("./middle"),
    right1: () => import("./right1"),
    right2: () => import("./right2"),
    right3: () => import("./right3")
    // webscoket: () => import("./webscoket")
  },

  methods: {
    markerClick({ areaId, areas }) {
      if (areas.length < 1) return;
      this.areaId = areaId;
      this.initMapData();
    },
    initMapData() {
      this.$axiosget("operation/home/findArea", {
        params: {
          areaId: 1
        }
      }).then(res => {
        this.rootData = res.data.data;
        this.deviceCount = this.rootData.deviceCount;
      });
    }
  },
  mounted() {
    this.initMapData();
    this.scaleX = $("#app").width() / 1920;
    this.scaleY = (window.innerHeight - 64) / 936;
    window.onresize = () => {
      this.scaleX = $("#app").width() / 1920;
      this.scaleY = (window.innerHeight - 64) / 936;
    };
  }
};
</script>

<style lang="less" scoped>
.outer {
  width: 100%;
  height: 100%;
  margin-left: -20px;
}

.main {
  width: 1920px;
  height: 936px;
  padding: 20px;
  display: flex;
  transform-origin: top left;
}

.left,
.right {
  width: 432px;
  position: relative;
  opacity: 1;
}

.left {
  margin-right: 12px;
}

.right {
  margin-left: 12px;
}

.middle {
  width: 993px;
  position: relative;
}

.map {
  width: 990px;
  height: 592px;
  border: 1px solid #2c354b;
  position: relative;
  opacity: 1;
}

.deviceCount {
  width: 160px;
  height: 50px;
  background: url("./deviceCount.png") no-repeat center 0 #0d0d1666;
  text-align: center;
  position: absolute;
  z-index: 99;
  top: 33px;
  left: 33px;
  line-height: 40px;

  .title {
    font-size: 14px;
    color: #36bfff;
    letter-spacing: 1px;
  }

  strong {
    font-size: 24px;
    color: #fff;
    margin-left: 8px;
    position: relative;
    top: 5px;
  }

  .unit {
    font-size: 12px;
    color: #fff;
    margin-left: 5px;
  }
}

.mapBox {
  height: 590px;
}

.picMap {
  width: 988px;
  height: 590px;
  position: absolute;
  bottom: 0;
  left: 0;
}

.mapTabs {
  width: 100%;
  height: 50px;
  padding-left: 26px;
  padding-top: 16px;
  background: rgba(31, 39, 60, 0.5);
  position: absolute;
  bottom: 0;
  left: 0;
}

.mapTabs ul {
  overflow: hidden;
}

.mapTabs li {
  float: left;
  margin-right: 14px;
  cursor: pointer;
}

.mapTabs li .iconfont,
.Deviceon .inner .iconfont {
  background: linear-gradient(180deg, #3ed3e6 20%, #3a7bef 60%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.mapTabs li.active span {
  color: #3ed3e6;
}

.mapTabs li .iconfont {
  font-size: 16px;
  position: relative;
  top: 1px;
}

.mapTabs li span {
  font-size: 14px;
  color: #ccc;
  display: inline-block;
  vertical-align: top;
  margin-top: 1px;
}

.quantityOfDevice section,
.equipmentStatusStatistics section,
.alarm section {
  margin: 15px auto;
  width: 100%;
  height: 206px;
}

.alarm {
  position: relative;
}

.alarm .bg {
  width: 175px;
  height: 175px;
  padding: 8px;
  background: #272e4a;
  background-clip: content-box;
  position: absolute;
  bottom: 6%;
  left: 50%;
  transform: translateX(-50%);
  border: 1px solid #1d749f;
  border-radius: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute1/home copy/index.vue